export class StarsController {
  static instance;

  constructor() {

  }

  static getInstance() {
    if (!StarsController.instance) {
      StarsController.instance = new StarsController();
    }
    return StarsController.instance;
  }

  renderOne(_score) {
    let starClass = 'zero';
    try {
      let score = parseFloat(_score);

      if (score >= 1 && score < 2) {
        starClass = 'one';
      } else if (score >= 2 && score < 3) {
        starClass = 'two';
      } else if (score >= 3 && score < 4) {
        starClass = 'three';
      } else if (score >= 4 && score < 4.75) {
        starClass = 'four';
      } else if (score >= 4.75) {
        starClass = 'five';
      }
    } catch (error) {
      console.error(error);
    }
    // return `<div class="stars full ${starClass}">${_score.toFixed(1)}</div>`;
    return `<div class="stars full ${starClass}"></div>`;
  }
}
